import { fetchConfig } from '../util/fetchConfig';
import { OUTBOUND_CONTEXT, OUTBOUND_CONTEXT_VARIABLES } from '../util/Constants';
import { getTokenFromMobile } from './helpers';

export const setRequestHeaders = () => {
  const headers = {
    Authorization: getTokenFromMobile(),
    'DEVICE-ID': window.urlParams.deviceId
  };

  if (window.urlParams.outboundContext)
    headers[OUTBOUND_CONTEXT] = window.urlParams.outboundContext;
  if (window.urlParams.outboundContextVariables)
    headers[OUTBOUND_CONTEXT_VARIABLES] = window.urlParams.outboundContextVariables;
  return headers;
};

export const fetchJWSToken = async () => {
  const config = await fetchConfig();
  const url = `${config.cards.apiBaseUrl}/token/omnichannel`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: setRequestHeaders()
    });
    const responseJson = await response.json();
    const shortTermAccessToken = await responseJson['idToken'];
    return shortTermAccessToken;
  } catch (error) {
    return error;
  }
};
